<app-header />
<!-- Sign Up Form -->
<div class="top_padding5">
  <div class="sign_up" id="sign-up">
    <div class="sign_up_modal text-center">
      <div class="p-x-50 w-100">
        <div *ngIf="successMessage" class="success-message">
          {{ successMessage }}
        </div>
        <div class="p-top-30 sign-in">
          <p class="text_black_13">
            Already have an account?
            <span
              class="text_blue_14 cursor-pointer"
              (click)="openSignInModal()"
              >Sign In</span
            >
          </p>
        </div>
        <div class="sign_up_modal_head">
          <div class="header_bottom_logo">
            <img
              class="header_bottom_logo_img"
              src="../../../assets/img/logo.png"
              alt="Logo"
            />
          </div>
          <div class="dis-flex-2">
            <span class="text_blue_9">Sign Up</span>
          </div>
          <div class="p-top-30 sign-in1">
            <p class="text_black_13">
              Already have an account?
              <span
                class="text_blue_14 cursor-pointer"
                (click)="openSignInModal()"
                >Sign In</span
              >
            </p>
          </div>
        </div>
        <div class="sign_up_modal_list dis-flex-1 p-top-20">
          <ng-container *ngFor="let detail of details">
            <div class="sign_up_modal_list_item width_33">
              <div class="sign_up_modal_list_item_grid">
                <div class="p-top-13_5">
                  <div class="hl_1"></div>
                </div>
                <div>
                  <svg
                    width="17"
                    height="17"
                    viewBox="0 0 17 17"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle
                      cx="8.5"
                      cy="8.5"
                      r="6"
                      fill="white"
                      stroke="#0032A0"
                      stroke-width="5"
                    ></circle>
                  </svg>
                  <div class="height-20 dis-flex-1">
                    <div class="vl_1 height-100-per"></div>
                  </div>
                </div>
                <div class="p-top-13_5">
                  <div class="hl_1"></div>
                </div>
              </div>
              <div class="p-top-12">
                <span class="text_blue_15">{{ detail }}</span>
              </div>
            </div>
          </ng-container>
        </div>
        <form [formGroup]="signUpForm" (ngSubmit)="submit_signup_form()">
          <div
            class="sign_up_modal_body modal-body"
            *ngIf="!showSecondForm && !showThirdForm"
          >
            <div>
              <div class="dis-flex-4">
                <div>
                  <span class="text_black_14"
                    >I am a Professional and describe myself as:</span
                  >
                </div>
                <div class="selected-count flex-1">
                  {{ selectedCountsignup || "0" }} selected
                </div>
              </div>
              <div class="">
                <div class="dis-flex-7 flex-wrap p-top-24">
                  <ng-container *ngFor="let label of labels; let i = index">
                    <div
                      class="p-x-25 p-y-11 dis-flex-4 border_blue_1 border-radius-22 m-r-16 m-b-16 bg_1"
                      [ngClass]="{
                        bg_3: label.checked,
                        'text_white_9 ': label.checked
                      }"
                    >
                      <input
                        type="checkbox"
                        id="checkbox{{ i }}"
                        name="checkbox{{ i }}"
                        (change)="toggleCheckbox(i)"
                        [checked]="label.checked"
                      />
                      <label
                        for="checkbox{{ i }}"
                        class="text_blue_5 p-l-10"
                        [ngClass]="{ text_white_9: label.checked }"
                        >{{ label.profession }}</label
                      >
                    </div>
                  </ng-container>
                </div>
              </div>
              <div class="text_align">
                <div class="">
                  <p class="text_black_14">Note:</p>
                </div>
                <div class="sign_up_modal_body_note">
                  <ul class="sign_up_modal_body_note_list">
                    <li
                      class="sign_up_modal_body_note_list_item text_black_5 p-top-8"
                      *ngFor="let list of lists; let i = index"
                    >
                      <div>
                        <div
                          class="width-18 height-18 bg_3 border-radius-50-per text_white_15 dis-flex-2"
                        >
                          {{ i + 1 }}
                        </div>
                      </div>
                      <div [innerHTML]="list"></div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="dis-flex-5 p-top-20 p-b-20 p-x-40">
              <button
                class="button_blue_4 text_white_1"
                [ngClass]="{ opacity: selectedCountsignup === 0 }"
                [disabled]="!isNextButtonEnabled()"
                (click)="toggleSecondForm()"
              >
                Next
              </button>
            </div>
          </div>
          <div
            class="sign_up_modal_body"
            *ngIf="showSecondForm && !showThirdForm"
          >
            <div class="sign_up_modal_body_form2">
              <div class="">
                <div class="sign_up_modal_body_form2_box1 dis-grid-2">
                  <div class="p-top-18 p-x-20">
                    <label for="affiliation" class="dis-flex-4 text_grey_2"
                      >Institute/Company Affiliation
                      <span class="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      id="affiliation"
                      formControlName="institute_company"
                      class="dis-flex-4 text_grey_3 height-40 border-radius-4 width-100-per p-x-15"
                      placeholder="Enter Institute/Company Affiliation"
                      required
                    />
                    <div
                      *ngIf="
                        isSubmitted &&
                        signUpForm.controls['institute_company'].invalid
                      "
                      class="text-start"
                    >
                      <small
                        class="text-red-1"
                        *ngIf="signUpForm.controls['institute_company'].errors?.['required']"
                        >Institute/Company Affiliation is required</small
                      >
                    </div>
                  </div>
                  <div class="p-top-18 p-x-20">
                    <label for="department" class="dis-flex-4 text_grey_2"
                      >Name of Department/ Business Verticals<span
                        class="text-danger"
                        >*</span
                      ></label
                    >
                    <input
                      type="text"
                      id="department"
                      formControlName="department_name"
                      class="dis-flex-4 text_grey_3 height-40 border-radius-4 width-100-per p-x-15"
                      placeholder="Enter Name of Department/ Business Verticals"
                      required
                    />
                    <div
                      *ngIf="
                        isSubmitted &&
                        signUpForm.controls['department_name'].invalid
                      "
                      class="text-start"
                    >
                      <small
                        class="text-red-1 text_align"
                        *ngIf="signUpForm.controls['department_name'].errors?.['required']"
                        >Name of Department/ Business Verticals is
                        required</small
                      >
                    </div>
                  </div>
                  <!-- <div class="p-top-18 p-x-20">
                                                    <label for="company_email_id" class="dis-flex-4 text_grey_2">Company Email
                                                        ID</label>
                                                    <input type="email" formControlName="company_email_id"
                                                        class="dis-flex-4 text_grey_3 height-40 border-radius-4 width-100-per p-x-15"
                                                        placeholder="Enter Company Email ID" required>
                                                    <div *ngIf="isSubmitted && signUpForm.controls['company_email_id'].invalid">
                                                        <small class="text-red-1 text_align"
                                                            *ngIf="signUpForm.controls['company_email_id'].errors?.['required']">Required</small>
                                                        <small class="text-red-1 text_align"
                                                            *ngIf="signUpForm.controls['company_email_id'].errors?.['email']">Invalid
                                                            email format</small>
                                                    </div>
                                                </div> -->

                  <div class="p-top-18 p-x-20">
                    <label for="industry" class="dis-flex-4 text_grey_2"
                      >Industry<span class="text-danger">*</span></label
                    >
                    <input
                      type="text"
                      id="industry"
                      required
                      formControlName="industry"
                      class="dis-flex-4 text_grey_3 height-40 border-radius-4 width-100-per p-x-15"
                      placeholder="Enter Industry"
                      required
                    />
                    <div
                      *ngIf="
                        isSubmitted && signUpForm.controls['industry'].invalid
                      "
                      class="text-start"
                    >
                      <small
                        class="text-red-1 text_align"
                        *ngIf="signUpForm.controls['industry'].errors?.['required']"
                        >Industry is required</small
                      >
                    </div>
                  </div>
                  <div class="p-top-18 p-x-20">
                    <label for="companyName" class="dis-flex-4 text_grey_2"
                      >Company Name<span class="text-danger">*</span></label
                    >
                    <input
                      type="text"
                      id="companyName"
                      formControlName="company_name"
                      class="dis-flex-4 text_grey_3 height-40 border-radius-4 width-100-per p-x-15"
                      placeholder="Enter Company Name"
                      required
                    />
                    <div
                      *ngIf="
                        isSubmitted &&
                        signUpForm.controls['company_name'].invalid
                      "
                      class="text-start"
                    >
                      <small
                        class="text-red-1 text_align"
                        *ngIf="signUpForm.controls['company_name'].errors?.['required']"
                        >Company Name is required</small
                      >
                    </div>
                  </div>
                  <div class="p-top-18 p-x-20">
                    <label for="occupation" class="dis-flex-4 text_grey_2"
                      >Occupation<span class="text-danger">*</span></label
                    >
                    <input
                      type="text"
                      id="occupation"
                      formControlName="occupation"
                      class="dis-flex-4 text_grey_3 height-40 border-radius-4 width-100-per p-x-15"
                      placeholder="Enter Occupation"
                      required
                    />
                    <div
                      *ngIf="
                        isSubmitted && signUpForm.controls['occupation'].invalid
                      "
                      class="text-start"
                    >
                      <small
                        class="text-red-1 text_align"
                        *ngIf="signUpForm.controls['occupation'].errors?.['required']"
                        >Occupation is required</small
                      >
                    </div>
                  </div>
                </div>
                <div>
                  <div class="text_align p-top-18 p-x-20">
                    <span class="text_black_14">Company Address</span>
                  </div>
                  <div class="dis-grid-2 sign_up_modal_body_form2_box2">
                    <div class="p-top-18 p-x-20">
                      <label for="country" class="dis-flex-4 text_grey_2"
                        >Country<span class="text-danger">*</span></label
                      >
                      <input
                        type="text"
                        id="country"
                        formControlName="country_name"
                        class="dis-flex-4 text_grey_3 height-40 border-radius-4 width-100-per p-x-15"
                        placeholder="Select Country"
                        required
                      />
                      <div
                        *ngIf="
                          isSubmitted &&
                          signUpForm.controls['country_name'].invalid
                        "
                        class="text-start"
                      >
                        <small
                          class="text-red-1 text_align"
                          *ngIf="signUpForm.controls['country_name'].errors?.['required']"
                          >Country is required</small
                        >
                      </div>
                    </div>
                    <div class="p-top-18 p-x-20">
                      <label for="state" class="dis-flex-4 text_grey_2"
                        >State<span class="text-danger">*</span></label
                      >
                      <input
                        type="text"
                        id="state"
                        formControlName="state"
                        class="dis-flex-4 text_grey_3 height-40 border-radius-4 width-100-per p-x-15"
                        placeholder="Enter State"
                        required
                      />
                      <div
                        *ngIf="
                          isSubmitted && signUpForm.controls['state'].invalid
                        "
                        class="text-start"
                      >
                        <small
                          class="text-red-1 text_align"
                          *ngIf="signUpForm.controls['state'].errors?.['required']"
                          >State is required</small
                        >
                      </div>
                    </div>
                    <div class="p-top-18 p-x-20">
                      <label for="addressLine" class="dis-flex-4 text_grey_2"
                        >Address<span class="text-danger">*</span></label
                      >
                      <input
                        type="text"
                        id="addressLine"
                        formControlName="address"
                        class="dis-flex-4 text_grey_3 height-40 border-radius-4 width-100-per p-x-15"
                        placeholder="Enter Address Line"
                        required
                      />
                      <div
                        *ngIf="
                          isSubmitted && signUpForm.controls['address'].invalid
                        "
                        class="text-start"
                      >
                        <small
                          class="text-red-1 text_align"
                          *ngIf="signUpForm.controls['address'].errors?.['required']"
                          >Address is required</small
                        >
                      </div>
                    </div>
                    <div class="p-top-18 p-x-20">
                      <label for="pinCode" class="dis-flex-4 text_grey_2"
                        >PIN Code<span class="text-danger">*</span></label
                      >
                      <input
                        type="text"
                        id="pinCode"
                        formControlName="pincode"
                        class="dis-flex-4 text_grey_3 height-40 border-radius-4 width-100-per p-x-15"
                        placeholder="PIN Code"
                        required
                      />
                      <div
                        *ngIf="
                          isSubmitted && signUpForm.controls['pincode'].invalid
                        "
                        class="text-start"
                      >
                        <small
                          class="text-red-1 text_align"
                          *ngIf="signUpForm.controls['pincode'].errors?.['required']"
                          >PIN Code is required</small
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="p-top-20 p-b-20 p-x-40 sign_up_modal_body_button1">
              <div class="sign_up_modal_body_button1_one">
                <button
                  class="text_blue_4 button_white_3"
                  (click)="toggleSecondForm()"
                >
                  Previous
                </button>
              </div>
              <div class="sign_up_modal_body_button1_two">
                <button
                  class="button_blue_4 text_white_1"
                  (click)="toggleThirdForm()"
                >
                  Next
                </button>
              </div>
            </div>
          </div>
          <div class="sign_up_modal_body" *ngIf="showThirdForm">
            <div class="">
              <div class="sign_up_modal_body_form3">
                <div class="sign_up_modal_body_form3_boxes">
                  <div class="p-x-20 dis-flex-7 p-top-18">
                    <div>
                      <label class="text_grey_2"
                        >Gender<span class="text-danger">*</span> :</label
                      >
                    </div>
                    <div class="dis-flex-7">
                      <div class="p-x-20">
                        <label class="text_black_13">
                          <input
                            type="radio"
                            formControlName="gender"
                            value="male"
                          />
                          Male
                        </label>
                      </div>
                      <div class="p-x-20">
                        <label class="text_black_13">
                          <input
                            type="radio"
                            formControlName="gender"
                            value="female"
                          />
                          Female
                        </label>
                      </div>
                      <div class="p-x-20">
                        <label class="text_black_13">
                          <input
                            type="radio"
                            formControlName="gender"
                            value="other"
                          />
                          Other
                        </label>
                      </div>
                    </div>
                    <div
                      *ngIf="
                        isSubmitted && signUpForm.controls['gender'].invalid
                      "
                    >
                      <small
                        class="text-red-1 text_align"
                        *ngIf="signUpForm.controls['gender'].errors?.['required']"
                        >Select atleast one</small
                      >
                    </div>
                  </div>

                  <div
                    class="dis-grid-3 width-100-per sign_up_modal_body_form3_boxes_box1"
                  >
                    <div class="dis-block-1 p-top-18 p-x-20">
                      <label for="title" class="dis-flex-4 text_grey_2"
                        >Title<span class="text-danger">*</span></label
                      >
                      <select
                        id="title"
                        formControlName="prefix"
                        class="dis-flex-4 text_grey_3 height-40 border-radius-4 width-100-per p-x-15"
                        required
                      >
                        <option value="" disabled selected>Select Title</option>
                        <option value="Mr">Mr</option>
                        <option value="Mrs">Mrs</option>
                        <option value="Ms">Ms</option>
                        <option value="Dr">Dr</option>
                        <option value="Prof">Prof</option>
                        <!-- Add more options as needed -->
                      </select>
                      <div
                        *ngIf="
                          isSubmitted && signUpForm.controls['prefix'].invalid
                        "
                        class="text-start"
                      >
                        <small
                          class="text-red-1 text_align"
                          *ngIf="signUpForm.controls['prefix'].errors?.['required']"
                          >Title is required</small
                        >
                      </div>
                    </div>

                    <div class="dis-block-1 p-top-18 p-x-20">
                      <label for="firstname" class="dis-flex-4 text_grey_2"
                        >First Name<span class="text-danger">*</span></label
                      >
                      <input
                        type="text"
                        id="firstname"
                        formControlName="firstname"
                        class="dis-flex-4 text_grey_3 height-40 border-radius-4 width-100-per p-x-15"
                        placeholder="Enter First Name"
                        required
                      />
                      <div
                        *ngIf="
                          isSubmitted &&
                          signUpForm.controls['firstname'].invalid
                        "
                        class="text-start"
                      >
                        <small
                          class="text-red-1 text_align"
                          *ngIf="signUpForm.controls['firstname'].errors?.['required']"
                          >First Name is required</small
                        >
                      </div>
                    </div>
                    <div class="dis-block-1 p-top-18 p-x-20">
                      <label for="Last Name" class="dis-flex-4 text_grey_2"
                        >Last Name<span class="text-danger">*</span></label
                      >
                      <input
                        type="text"
                        id="Last Name"
                        formControlName="lastname"
                        class="dis-flex-4 text_grey_3 height-40 border-radius-4 width-100-per p-x-15"
                        placeholder="Enter Last Name"
                        required
                      />
                      <div
                        *ngIf="
                          isSubmitted && signUpForm.controls['lastname'].invalid
                        "
                        class="text-start"
                      >
                        <small
                          class="text-red-1 text_align"
                          *ngIf="signUpForm.controls['lastname'].errors?.['required']"
                          >Last Name is required</small
                        >
                      </div>
                    </div>
                  </div>
                  <div
                    class="dis-grid-2 width-100-per sign_up_modal_body_form3_boxes_box2"
                  >
                    <div class="dis-block-1 p-top-18 p-x-20">
                      <div class="text_align">
                        <label class="text_grey_2"
                          >Phone<span class="text-danger">*</span></label
                        >
                      </div>
                      <div class="width-100-per">
                        <!-- <select id="countryCode" formControlName="country_code"
                                                            class="text_grey_3 height-40 border-radius-4  p-x-10 width-20-per">
                                                            <option *ngFor="let country of countries" [value]="country.code">
                                                                {{ country.code }}
                                                                Only display the code, since img tag cannot be used within an <option>  
                                                            </option>
                                                        </select> -->
                        <input
                          type="tel"
                          id="phone"
                          name="phone"
                          class="text_grey_3 height-40 border-radius-4 width-100-per p-x-15"
                          placeholder="626 611 7944"
                          formControlName="mobile_no"
                        />
                        <div
                          *ngIf="
                            isSubmitted &&
                            signUpForm.controls['mobile_no'].invalid
                          "
                          class="text-start"
                        >
                          <small
                            class="text-red-1 text_align"
                            *ngIf="signUpForm.controls['mobile_no'].errors?.['required']"
                            >Phone number is required</small
                          >
                        </div>
                      </div>
                    </div>
                    <div class="dis-block-1 p-top-18 p-x-20">
                      <label for="email2" class="dis-flex-4 text_grey_2"
                        >Email<span class="text-danger">*</span></label
                      >
                      <input
                        type="email"
                        id="email2"
                        formControlName="email"
                        class="dis-flex-4 text_grey_3 height-40 border-radius-4 width-100-per p-x-15"
                        placeholder="Enter Email"
                        required
                      />
                      <div
                        *ngIf="
                          isSubmitted && signUpForm.controls['email'].invalid
                        "
                        class="text-start"
                      >
                        <small
                          class="text-red-1 text_align"
                          *ngIf="signUpForm.controls['email'].errors?.['required']"
                          >Email is required</small
                        >
                        <small
                          class="text-red-1 text_align"
                          *ngIf="signUpForm.controls['email'].errors?.['email']"
                          >Invalid email address</small
                        >
                      </div>
                    </div>

                    <div class="dis-block-1 p-top-18 p-x-20">
                      <label for="email3" class="dis-flex-4 text_grey_2"
                        >Education<span class="text-danger">*</span></label
                      >
                      <input
                        type="text"
                        id="email3"
                        formControlName="education"
                        class="dis-flex-4 text_grey_3 height-40 border-radius-4 width-100-per p-x-15"
                        placeholder="Enter Education"
                        required
                      />
                      <div
                        *ngIf="
                          isSubmitted &&
                          signUpForm.controls['education'].invalid
                        "
                        class="text-start"
                      >
                        <small
                          class="text-red-1 text_align"
                          *ngIf="signUpForm.controls['education'].errors?.['required']"
                          >Education is required</small
                        >
                      </div>
                    </div>
                    <div class="dis-block-1 p-top-18 p-x-20">
                      <label for="email4" class="dis-flex-4 text_grey_2"
                        >Password<span class="text-danger">*</span></label
                      >
                      <input
                        type="password"
                        id="email4"
                        formControlName="password"
                        class="dis-flex-4 text_grey_3 height-40 border-radius-4 width-100-per p-x-15"
                        placeholder="Enter Password"
                        required
                      />
                      <div
                        *ngIf="
                          isSubmitted && signUpForm.controls['password'].invalid
                        "
                        class="text-start"
                      >
                        <small
                          class="text-red-1 text_align"
                          *ngIf="signUpForm.controls['password'].errors?.['required']"
                          >Password is required</small
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="text_align p-top-24 p-x-15 sign_up_modal_body_data1">
                <span class="text_black_14">Terms and conditions:</span>
                <p class="text_black_13">
                  We want you to know how our website works and how we use your
                  information when you register for the ChemRobotics®. Please
                  confirm that you have read and agree to these terms before
                  continuing.
                </p>
                <div class="dis-flex-4">
                  <div class="dis-flex-2">
                    <input
                      type="checkbox"
                      id="checkbox"
                      class="m-1"
                      name="checkbox"
                      value="yes"
                    />
                    <div class="text_black_13 p-l-3">
                      I agree to the
                      <span class="text_blue_2 cursor-pointer">
                        <a
                          href="https://www.chemrobotics.com/agropat/uploads/legal/ChemRobotics_Terms_of_use.pdf"
                          target="_blank"
                        >
                          Terms of use
                        </a>
                      </span>
                      and<span class="text_blue_2 cursor-pointer">
                        <a
                          href="https://www.chemrobotics.com/agropat/uploads/legal/ChemRobotics_Privacy_Policy.pdf"
                          target="_blank"
                        >
                          Privacy policy
                        </a>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="text_align p-top-18 p-x-15 sign_up_modal_body_data2">
                <span class="text_black_14">Contact permission:</span>
                <p class="text_black_13">
                  We'd like to keep you updated with news about the
                  ChemRobotics®, new services and features by email. We treat
                  your personal information with care and will never sell them
                  to other companies for marketing purposes.
                </p>
                <p class="text_black_13">
                  Please let us know if you would like to be contacted by
                  selecting one of the options below.
                </p>
                <div class="sign_up_modal_body_data2_box">
                  <div class="p-x-5">
                    <label class="radio-item text_black_13">
                      <input
                        type="radio"
                        value="true"
                        formControlName="notify_update"
                      />
                      Yes please, keep me updated with news about the
                      ChemRobotics®
                    </label>
                  </div>
                  <div class="p-x-5">
                    <label class="radio-item p-x-15 text_black_13">
                      <input
                        type="radio"
                        value="false"
                        formControlName="notify_update"
                      />
                      No thanks, I do not want to be updated with news about the
                      ChemRobotics®
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <div class="dis-grid-2">
              <div class="m-t-20">
                <re-captcha
                  class="m-t-20"
                  (resolved)="onCaptchaSuccess($event)"
                  [siteKey]="recaptchaSiteKey"
                >
                </re-captcha>
              </div>
              <!-- <div *ngIf="errorMessage" class="text-red-1 text_align">{{ errorMessage }}</div> -->

              <div class="p-top-10 p-b-20 p-x-40 sign_up_modal_body_button1">
                <div class="sign_up_modal_body_button1_one">
                  <button
                    class="text_blue_4 button_white_3"
                    (click)="previousForm()"
                  >
                    Previous
                  </button>
                </div>

                <div class="sign_up_modal_body_button1_two">
                  <button type="submit" class="button_blue_4 text_white_1">
                    Submit
                  </button>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
<app-footer />
